<template>
    <v-menu
        v-model="showPopup"
        :close-on-content-click="false"
        lazy
        transition="scale-transition"
        offset-y
        max-width="290"
        :disabled="disabled"
    >
        <template v-slot:activator="{ on }">
            <v-text-field
                v-model="date"
                :label="label"
                readonly
                persistent-hint
                v-on="on"
                :rules="dateRules"
                :prepend-inner-icon=prependInnerIcon?prependInnerIcon:undefined
                :error-messages="errorMessages"
                :disabled="disabled"
                :flat="flat"
                :solo="solo"
                :background-color="backgroundColor"
                :placeholder="placeholder"
                :append-icon="appendIcon"
                @click:append="showPopup=true"
                :hide-details="hideDetails"
            ></v-text-field>
        </template>
        <v-date-picker
            v-model="date"
            no-title
            show-current
            :min="min"
            :max="max"
            ref="VDatePicker"
            :disabled="disabled"
        ></v-date-picker>
    </v-menu>
</template>

<script>
import moment from 'moment'
import FormMixin from '@/mixins/FormMixin'

export default {
    name: 'DatePicker',
    mixins: [FormMixin],
    props: {
        value: String,
        label: String,
        rules: Array,
        min: String,
        max: String,
        errorMessages: String,
        prependInnerIcon: {
          type: String,
          default: "mdi-calendar"
        },
        hideDetails: {
            type: Boolean,
          default: false
        },
        appendIcon: {
          type: String,
          default: ""
        },
        placeholder: {
          type: String
        },
        backgroundColor: {
          type: String
        },
        solo: {
          type: Boolean,
          default: false
        },
        flat: {
          type: Boolean,
          default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
    },
    data () {
        return {
            showPopup: false,
            date: this.value
        }
    },
    computed: {
        dateRules () {
            if (this.rules) {
                return [
                    this.formRules.ruleDatePicker,
                    ...this.rules
                ]
            } else {
                return [this.formRules.ruleDatePicker]
            }
        }
    },
    watch: {
        value (value) {
            this.date = value
        },
        date () {
            this.$emit('input', this.date)
            this.showPopup = false
        },
        showPopup: {
            handler: function (val) {
                if (val) {
                    // show view at current value > min value or current month on open date picker
                    this.$nextTick(() => {
                        if (this.value) {
                            this.$refs.VDatePicker.tableDate = moment(this.value).format('YYYY-MM')
                            return
                        }
                        let today = moment().format('YYYY-MM')
                        let viewDay = today
                        if (this.min) {
                            let minDay = moment(this.min)
                            if (minDay.diff(today, 'days') > 0) {
                                viewDay = minDay.format('YYYY-MM')
                            }
                        }
                        this.$refs.VDatePicker.tableDate = viewDay
                    })
                }
            }
        }
    },
}
</script>

<style scoped>

</style>
